import { render, staticRenderFns } from "./CyberRiskAwareWizard.vue?vue&type=template&id=52d62b39&"
import script from "./CyberRiskAwareWizard.vue?vue&type=script&lang=js&"
export * from "./CyberRiskAwareWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports